const CCTransform = () => {
	return (
		<>
			<path
				d="M7.70995 14.68H6.70995C6.70995 11.02 3.72995 8.04002 0.0699463 8.04002V7.04002C3.72995 7.04002 6.70995 4.06002 6.70995 0.400024H7.70995C7.70995 4.06002 10.6899 7.04002 14.3499 7.04002V8.04002C10.6899 8.04002 7.70995 11.02 7.70995 14.68ZM2.78995 7.54002C4.81995 8.32002 6.42995 9.93003 7.20995 11.96C7.97995 9.93003 9.59995 8.32002 11.6299 7.54002C9.59995 6.76002 7.98995 5.15002 7.20995 3.12002C6.43995 5.15002 4.81995 6.76002 2.78995 7.54002Z"
				fill="#002D55"
			/>
			<path
				d="M16.63 10.99C16.63 13.91 14.26 16.29 11.33 16.29C14.25 16.29 16.63 18.66 16.63 21.59C16.63 18.67 19 16.29 21.93 16.29C19.01 16.29 16.63 13.92 16.63 10.99Z"
				fill="#BADDF4"
			/>
			<path
				d="M17.13 21.58H16.13C16.13 18.94 13.98 16.78 11.33 16.78V15.78C13.97 15.78 16.13 13.63 16.13 10.98H17.13C17.13 13.62 19.28 15.78 21.93 15.78V16.78C19.28 16.78 17.13 18.93 17.13 21.58ZM13.68 16.29C14.99 16.87 16.04 17.93 16.62 19.23C17.2 17.92 18.26 16.87 19.56 16.29C18.25 15.71 17.2 14.65 16.62 13.35C16.04 14.66 14.98 15.71 13.68 16.29Z"
				fill="#002D55"
			/>
		</>
	);
};

export default CCTransform;
